/**
 * Import additional modules here:
 *
 * import './module_xyz';
 */

import Slider from "./Slider";
import Hamburger from './Hamburger';
import Header from "./Header";
import Parallax from "./Parallax";
import Blog from "./Blog";
import PeopleModal from "./PeopleModal";

require('fslightbox');

/**
 * Main App module used in index.js to initialise all other modules, includes helper
 * functions/modules for use in initialising modules depending on various criteria
 *
 * @returns {{init: init}}
 */
export default (() => {
  const init = () => {
    Hamburger.init();
    Header.init();
    Parallax.init();
    Slider.init();
    Blog.init();
    PeopleModal.init();

    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    function isMacintosh() {
      return navigator.platform.indexOf('Mac') > -1;
    }

    function isWindows() {
      return navigator.platform.indexOf('Win') > -1;
    }

    if (isWindows()) {
      document.body.classList.add('windows');
    }

    if (isMacintosh()) {
      document.body.classList.add('mac');
    }

    if (isSafari) {
      document.body.classList.add('is-safari');
    }
  };

  return {
    init,
  };
})();
